import { AD_LINK_MANAGER, QUICK_LINK_ANALYTICS, QUICK_LINK_MANAGER } from '../../constants';
import { ProductFlagValues } from '../../ProductFlipperFlag.service';

export type DimensionToProductsMapType = Map<string, any>;

export const DimensionProductMapping: DimensionToProductsMapType = new Map<
  string,
  {
    enabled: boolean;
    condition: (flags: ProductFlagValues) => boolean;
  }
>([
  [
    'last_attributed_touch_data_tilde_id',
    {
      enabled: true,
      condition: (flags: ProductFlagValues) => {
        return (
          ((flags[QUICK_LINK_MANAGER] || flags[AD_LINK_MANAGER]) && flags[QUICK_LINK_ANALYTICS]) ||
          (!flags[QUICK_LINK_MANAGER] && !flags[AD_LINK_MANAGER]) ||
          false
        );
      },
    },
  ],
]);
